import moment from 'moment';
import { SEARCH_DATE_FORMAT, DAYS_PARAM } from 'common/constants/constants';

export const GOALS_PERIOD = '30';
export const ISSUES_PERIOD = '30';

export const today = moment().format(SEARCH_DATE_FORMAT);

export const metricsStartPeriodDate = period =>
  moment().subtract(period, DAYS_PARAM).format(SEARCH_DATE_FORMAT);
